export default "__VITE_ASSET__CIqre2hT__"